// Mapping between professional and household product IDs
export const PRODUCT_MAPPINGS = {
  // Professional to Household mappings
  'professional': {
    '294H0Kf9jpMSelwtNVYMrc': '2Yw0Kf9jpMSelwtNVYMrc', // Degreaser
    '3Xw0Kf9jpMSelwtNVYMrc': '4Yw0Kf9jpMSelwtNVYMrc', // Glass Cleaner
    '5Zw0Kf9jpMSelwtNVYMrc': '6Yw0Kf9jpMSelwtNVYMrc', // All Purpose Cleaner
    // Add more mappings as needed
  },
  // Household to Professional mappings
  'household': {
    '2Yw0Kf9jpMSelwtNVYMrc': '294H0Kf9jpMSelwtNVYMrc', // Degreaser
    '4Yw0Kf9jpMSelwtNVYMrc': '3Xw0Kf9jpMSelwtNVYMrc', // Glass Cleaner
    '6Yw0Kf9jpMSelwtNVYMrc': '5Zw0Kf9jpMSelwtNVYMrc', // All Purpose Cleaner
    // Add more mappings as needed
  }
};

// Helper function to get the corresponding product ID
export const getCorrespondingProductId = (currentId, currentType, targetType) => {
  const mappings = PRODUCT_MAPPINGS[currentType];
  if (!mappings) return null;

  return mappings[currentId] || null;
}; 